export const __ModalLang = {
    request: 'درخواست شرکت در دورهمی',
    close: 'بستن',
    number_people: 'تعداد نفرات',
    placeholder_capacity: 'تعداد نفرات خود را وارد کنید',
    placeholder_desc: 'توضیحات درباره خودتان بنویسید',
    desc: 'توضیحات',
    submit: 'ثبت درخواست',
};
